export default "__VITE_ASSET__DGFOQRvQ__"